module.exports = __webpack_public_path__ + "img/20191127164134498.4d9bfe5d.jpg";